<form [formGroup]="dynamicFormGroup">
  <div fxLayout="row wrap" fxLayoutAlign="space-between start">
    <div
      *ngFor="let field of fields"
      [ngStyle]="{ width: field.width }"
      style="padding: 10px"
    >
      <app-dynamic-fields [field]="field"></app-dynamic-fields>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-around center" *ngIf="!guardando">
    <button mat-stroked-button color="warn" (click)="cancelar()">
      Cancelar
    </button>
    <button mat-stroked-button color="success" (click)="guardar()">
      Guardar
    </button>
  </div>
  <mat-progress-bar mode="indeterminate" *ngIf="guardando"></mat-progress-bar>
</form>
